import { logUsage } from 'owa-analytics';
import { ClientItem } from 'owa-mail-store';
import { mutatorAction } from 'satcheljs';

const INVALID_THREAD_ID_REGEX = new RegExp('[^0-9]');

export default mutatorAction('setYammerThreadId', (item: ClientItem) => {
    // In case we have already parsed the yammer thread id, there's no need to do it again.
    if (item.YammerThreadId || !item.YammerNotification) {
        return;
    }

    const notificationProps = parseYammerNotification(item.YammerNotification);
    const parsedThreadId = notificationProps['threadId'];
    if (parsedThreadId && notificationProps['type'] == 'CopyOfMessage') {
        const isValidId = !INVALID_THREAD_ID_REGEX.test(parsedThreadId);
        if (!isValidId) {
            logUsage('Yammer_InvalidId', { parsedThreadId: parsedThreadId }, { logEvery: 1 });
        } else {
            item.YammerThreadId = parsedThreadId;
        }
    } else {
        // If we failed to parse it, set it as not being a yammer thread so that we don't try again
        logUsage(
            'Yammer_FailedToParseId',
            { YammerNotificationHeader: item.YammerNotification },
            { logEvery: 1 }
        );
    }
});

function parseYammerNotification(yammerNotificationString: string): { [key: string]: string } {
    // Current known format is: 'type=CopyOfMessage;messageId={messageId};threadId={threadId}'
    // Currently messageId isn't used.
    const notificationPropsStrings = yammerNotificationString.split(';');
    let notificationProps: { [key: string]: string } = {};
    for (let i = 0; i < notificationPropsStrings.length; i++) {
        const notificationProp = notificationPropsStrings[i].split('=', 2);
        if (notificationProp.length != 2) {
            continue;
        }

        notificationProps[notificationProp[0]] = notificationProp[1];
    }

    return notificationProps;
}
